enum RoleEnum {
    Borrower = 'BORROWER',
    Broker = 'BROKER',
    Investor = 'INVESTOR',
    Unauthenticated = 'UNAUTHENTICATED',
}

export default RoleEnum;
